import type * as THREE from 'three';
import type { FilletFeatureDefinitionModel } from '../../../feature/definition/fillet/FilletFeatureDefinition';
import type { FilletFeaturePrototype } from '../../../feature/prototype/fillet/FilletFeaturePrototype';
import { FeaturePreviewObject } from '../FeaturePreviewObject';

/**
 * 圆角预览体对象。
 */
export class FilletPreviewObject extends FeaturePreviewObject<
    FilletFeaturePrototype,
    FilletFeatureDefinitionModel
> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: FilletFeaturePrototype;
        draftDefinition: FilletFeatureDefinitionModel;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
